import React, { useState, useEffect } from "react";
import { FaSearch, FaCog, FaBell } from "react-icons/fa";
import { io } from "socket.io-client";
import "./AdminNavbar.css";
const apiUrl = process.env.REACT_APP_API_BASE_URL;
const socket = io(`${apiUrl}`);

function AdminNavbar() {
  const [notifications, setNotifications] = useState(0);
  const [user, setUser] = useState({
    name: "Admin",
    email: "inquiry.123coderwing@gmail.com",
    image: "https://randomuser.me/api/portraits/men/1.jpg",
  });

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    if (storedUser) {
      setUser(storedUser);
    }

    socket.on("databaseUpdate", (data) => {
      console.log("New update:", data);
      setNotifications((prev) => prev + 1);
    });

    return () => {
      socket.off("databaseUpdate");
    };
  }, []);

  return (
    <div className="navbarss">
      <div className="navbar-left">
        <span className="greeting">Hello {user.name} 👋</span>
      </div>

      <div className="search-bar">
        <FaSearch className="search-icon" />
        <input type="text" placeholder="Search..." />
      </div>

      <div className="navbar-right">
        <span className="icon notification">
          <FaBell />
          {notifications > 0 && <span className="badge">{notifications}</span>}
        </span>

        <span className="icon">
          <FaCog />
        </span>

        <div className="profile">
          <img src={user.image} alt="Profile" className="profile-img" />
          <div className="profile-info">
            <span className="profile-name">{user.name}</span>
            <span className="profile-email">{user.email}</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminNavbar;
